import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store/store"
import "./registerServiceWorker"
import Buefy from 'buefy'
import VueSelect from 'vue-cool-select'
import axios from 'axios'

Vue.use(Buefy)
Vue.use(require('vue-moment'));
Vue.use(VueSelect, {
    theme: 'bootstrap' // or 'material-design'
})
Vue.config.productionTip = false;

axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    if (error.response.status == 401) {
        localStorage.removeItem("jwt")
        window.location.reload()
    }
    if (error.response.status == 403) {
        localStorage.removeItem("jwt")
        window.location.reload()
    }
    return Promise.reject(error);
});


new Vue({
    router,
    store,
    render: h => h(App),
    created: function () {

    }
}).$mount("#app");